// src/redux/requestsSlice.js
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {server} from '../server';

// Async thunk to fetch all requests for a user
export const fetchRequests = createAsyncThunk(
  'requests/fetchRequests',
  async (userId, thunkAPI) => {
    try {
      const token = localStorage.getItem('authToken');

      const [sentRes, receivedRes] = await Promise.all([
        fetch(`${server}/requests/GetAllSentRequests?userId=${userId}`, {
          method: 'GET',
          headers: {Authorization: token},
        }),
        fetch(`${server}/requests/GetAllReceivedRequests?userId=${userId}`, {
          method: 'GET',
          headers: {Authorization: token},
        }),
      ]);

      if (!sentRes.ok || !receivedRes.ok) {
        throw new Error('Failed to fetch requests');
      }

      const [sentData, receivedData] = await Promise.all([
        sentRes.json(),
        receivedRes.json(),
      ]);

      return {
        sentRequests: sentData.requests || [],
        receivedRequests: receivedData.requests || [],
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

const requestsSlice = createSlice({
  name: 'requests',
  initialState: {
    sentRequests: [],
    receivedRequests: [],
    acceptedRequests: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearRequests(state) {
      state.sentRequests = [];
      state.receivedRequests = [];
      state.acceptedRequests = [];
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchRequests.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.sentRequests = action.payload.sentRequests;
        state.receivedRequests = action.payload.receivedRequests;
        state.acceptedRequests = [
          ...action.payload.sentRequests.filter(r => r.status === 'Accepted'),
          ...action.payload.receivedRequests.filter(
            r => r.status === 'Accepted',
          ),
        ];
      })
      .addCase(fetchRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch requests';
      });
  },
});

export const {clearRequests} = requestsSlice.actions;
export default requestsSlice.reducer;
